const actions = {
  listarCompras: async (
    context,
    {
      vendor_id,
      compra_sugerida = 0,
      per_page,
      page,
      search,
      compra_em_aberto,
      stock,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/vendors/reports/mrp`, {
      params: {
        per_page,
        vendor_id,
        page,
        compra_sugerida,
        search,
        compra_em_aberto,
        stock,
      },
    });

    return response;
  },
  exportarCompras: async (
    context,
    {
      page,
      search,
      vendor_id,
      compra_aberta,
      compra_sugerida,
      per_page,
      reposicao,
      stock,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/vendors/reports/mrp`, {
      params: {
        vendor_id,
        compra_sugerida,
        download: "xlsx",
        per_page,
        reposicao,
        stock,
        compra_aberta,
        search,
        page,
      },
    });

    return response;
  },
  atualizar: async (context) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/vendors/reports/recalcular-mrp`);

    return response;
  },

  upload: async (context, { planilha, mapeamento, adicional }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.post(`/manutencao-planilha`, {
      planilha,
      mapeamento,
      adicional,
    });

    return response;
  },

  getSolicitantes: async (context, { vendor_id, search, page }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/auth/users`, {
      params: {
        per_page: 8,
        vendor_id,
        search,
        page,
      },
    });

    return response;
  },

  getCentrosCustos: async (context, { vendor_id, search, page }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/cost-centers`, {
      params: {
        per_page: 8,
        vendor_id,
        search,
        page,
      },
    });

    return response;
  },

  getProdutosLista: async (context, { vendor_id, produto, sem_obsoleto }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/products/listagem-simples`, {
      params: {
        produto,
        vendor_id,
        sem_obsoleto,
      },
    });

    return response;
  },

  criarNecessidadeSolicitante: async (
    context,
    {
      vendor_id,
      cost_center_id,
      solicitante_id,
      tag_id,
      produtos,
      observacao,
      data_aplicacao,
      detalhamento_tecnico,
      responsabilidades_fornecedores,
      responsabilidades_contratante,
      possiveis_fornecedores,
      justificativa_contratacao,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.post(`/necessidade-compra/produtos`, {
      cost_center_id,
      solicitante_id,
      tag_id,
      produtos,
      vendor_id,
      observacao,
      data_aplicacao,
      detalhamento_tecnico,
      responsabilidades_fornecedores,
      responsabilidades_contratante,
      possiveis_fornecedores,
      justificativa_contratacao,
    });

    return response;
  },

  getGrupos: async (context, { vendor_id, search }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/product-groups`, {
      params: {
        per_page: 8,
        vendor_id,
        search,
      },
    });

    return response;
  },

  getProdutos: async (context, { vendor_id, search, grupo_id, page }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/products/listagem-simples`, {
      params: {
        per_page: 8,
        vendor_id,
        search,
        page,
        grupo_id,
      },
    });

    return response;
  },

  criarNecessidade: async (
    context,
    {
      cost_center_id,
      solicitante_id,
      tag_id,
      vendor_id,
      produtos,
      observacao,
      data_aplicacao,
      detalhamento_tecnico,
      responsabilidades_fornecedores,
      responsabilidades_contratante,
      possiveis_fornecedores,
      justificativa_contratacao,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.post(`/necessidade-compra/produtos`, {
      vendor_id,
      cost_center_id,
      produtos,
      solicitante_id,
      tag_id,
      observacao,
      data_aplicacao,
      detalhamento_tecnico,
      responsabilidades_fornecedores,
      responsabilidades_contratante,
      possiveis_fornecedores,
      justificativa_contratacao,
    });

    return response;
  },

  criarNecessidadeRequisicao: async (
    context,
    { plantiff_id, cost_center_id, vendor_id, products }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.post(`/vouchers`, {
      cost_center_id,
      plantiff_id,
      vendor_id,
      products,
    });

    return response;
  },

  semAssociaçãoCatalogo: async (
    context,
    {
      page,
      per_page,
      produto,
      responsavel,
      user,
      data_inicial,
      data_final,
      comprado,
      com_comprador,
      numero,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/necessidade-compra/itens-fora-catalogo`, {
      params: {
        associado: 0,
        data_inicial,
        data_final,
        page,
        per_page,
        produto,
        responsavel,
        user,
        comprado,
        com_comprador,
        numero,
      },
    });

    return response;
  },

  semAssociaçãoCatalogoExportar: async (
    context,
    { data_inicial, data_final, produto, responsavel, user, comprado, numero }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/necessidade-compra/itens-fora-catalogo`, {
      params: {
        associado: 0,
        data_inicial,
        data_final,
        download: "excel",
        produto,
        responsavel,
        user,
        comprado,
        numero,
      },
    });

    return response;
  },

  produtosAbertos: async (
    context,
    {
      page,
      per_page,
      comprado,
      produto,
      responsavel,
      user,
      data_inicial,
      data_final,
      associado = 2,
      com_comprador,
      numero,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/necessidade-compra/detalhada`, {
      params: {
        associado,
        data_inicial,
        data_final,
        page,
        per_page,
        comprado,
        produto,
        responsavel,
        user,
        com_comprador,
        numero,
      },
    });

    return response;
  },

  produtosAbertos2: async (
    context,
    {
      page,
      per_page,
      comprado = 2,
      produto,
      responsavel,
      user,
      data_inicial,
      data_final,
      associado,
      download,
      com_comprador,
      numero,
      criador,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/necessidade-compra/detalhada`, {
      params: {
        associado,
        data_inicial,
        data_final,
        page,
        per_page,
        comprado,
        produto,
        responsavel,
        user,
        download,
        com_comprador,
        numero,
        criador,
      },
    });

    return response;
  },

  produtosAbertosExport: async (
    context,
    { comprado, produto, responsavel, user, data_inicial, data_final, numero }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/necessidade-compra/detalhada`, {
      params: {
        associado: 2,
        data_inicial,
        data_final,
        download: "excel",
        comprado,
        produto,
        responsavel,
        user,
        numero,
      },
    });

    return response;
  },

  necessidadeAssociados: async (
    context,
    { vendor_id, page, per_page, associado, numero, user }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/necessidade-compra?associado`, {
      params: {
        data_inicial: "01/01/2021",
        vendor_id,
        page,
        per_page,
        numero,
        associado,
        user,
      },
    });

    return response;
  },

  acompanhar: async (context, { uuid }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/necessidade-compra/detalhada`, {
      params: {
        data_inicial: "01/01/2001",
        per_page: 1000,
        uuid,
      },
    });

    return response;
  },

  exportarAcompanhar: async (context, { uuid }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/necessidade-compra/detalhada`, {
      params: {
        data_inicial: "01/01/2021",
        per_page: 1000,
        uuid,
        comprado: 2,
        download: "excel",
      },
    });

    return response;
  },

  uploadAcompanhar: async (context, { uuid, arquivo }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/necessidade-compra/${uuid}/arquivo`, {
      arquivo,
      need_uuid: uuid,
    });

    return response;
  },

  getArquivosAcompanhar: async (context, { uuid, timestamp }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/necessidade-compra/${uuid}/arquivos`, {
      params: timestamp ? { _t: timestamp } : {},
    });

    return response;
  },

  deletarNecessidade: async (context, { uuid }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.delete(`/necessidade-compra/${uuid}`);

    return response;
  },

  deletarArquivoAcompanhar: async (context, { uuid }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.delete(`/necessidade-compra/arquivo/${uuid}`);

    return response;
  },

  setScNumero: async (context, { uuid, cod_integracao, observacao }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/necessidade-compra/${uuid}`, {
      cod_integracao,
      observacao,
      uuid,
    });

    return response;
  },

  removerResponsavelSemReferencia: async (context, { uuid, uuidItem }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/necessidade-compra/${uuid}/item-fora-catalogo/${uuidItem}/remover-responsavel`,
      {
        uuid,
        uuidItem,
      }
    );

    return response;
  },

  removerResponsavelNecessidade: async (context, { uuid, uuidItem }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/necessidade-compra/${uuid}/item/${uuidItem}/remover-responsavel`,
      {
        uuid,
        uuidItem,
      }
    );

    return response;
  },

  deletarSemReferencia: async (context, { uuid, uuid_itens }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/necessidade-compra/${uuid}/remover-item-fora-catalogo`,
      {
        uuid_itens,
        uuid,
      }
    );

    return response;
  },

  exportarSemReferencia: async (context, { uuid, numero }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/necessidade-compra/itens-fora-catalogo`, {
      params: {
        data_inicial: "01/01/2001",
        per_page: 1000,
        uuid,
        comprado: 2,
        associado: 0,
        download: "excel",
        numero,
      },
    });

    return response;
  },
  editarSemReferencia: async (context, { uuid, need_id, item }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/necessidade-compra/${need_id}/item-fora-catalogo/${uuid}`,
      {
        item,
        need_id,
        uuid,
      }
    );

    return response;
  },
  editarSemReferenciaCodigo: async (context, { uuid, produtos }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/necessidade-compra/${uuid}/vincular`, {
      need_uuid: uuid,
      produtos,
    });

    return response;
  },

  getProdutosDetalhe: async (context, { uuid }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/necessidade-compra/detalhada`, {
      data_inicial: "01/01/2001",
      per_page: 1000,
      uuid,
      comprado: 2,
    });

    return response;
  },

  exportarProdutosNecessidade: async (context, { uuid }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/necessidade-compra/detalhada`, {
      params: {
        data_inicial: "01/01/2001",
        per_page: 1000,
        uuid,
        comprado: 2,

        download: "excel",
      },
    });

    return response;
  },

  deletarProdutosNecessidade: async (context, { uuid, produtos }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/necessidade-compra/${uuid}/desvincular`, {
      produtos: produtos,
      need_uuid: uuid,
    });

    return response;
  },

  excluirCodigo: async (context, { uuid, uuid_itens }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/necessidade-compra/${uuid}/remover-produtos`,
      {
        uuid_itens: uuid_itens,
        need_uuid: uuid,
      }
    );

    return response;
  },

  purchaseDetalhes: async (
    context,
    { vendor_id, page, per_page, provider }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/purchase-order`, {
      params: {
        data_inicial: "01/01/2001",
        page,
        per_page,
        status: "criado",
        vendor: vendor_id,
        provider,
      },
    });

    return response;
  },

  criarRequisicao: async (
    context,
    { cost_center_id, plantiff_id, numero, products, vendor_id }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.post(`/vouchers`, {
      cost_center_id,
      description: `Voucher criado a partir da necessidade de compra ${numero}`,
      plantiff_id,
      products,
      vendor_id,
    });

    return response;
  },

  historicoNecessidade: async (context, { uuid }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/necessidade-compra/${uuid}/historico`);

    return response;
  },

  getProdutosNecessidade: async (context, { page, per_page, uuid }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/necessidade-compra/detalhada`, {
      params: {
        comprado: 2,
        data_inicial: "01/01/2001",
        page,
        per_page,
        uuid,
      },
    });

    return response;
  },

  incluirProduto: async (context, { purchase_id, products }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/purchase-order/${purchase_id}/products`, {
      products,
      purchase_id,
    });

    return response;
  },

  editarProduto: async (context, { purchase_id, products }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/purchase-order/${purchase_id}/products/atualizar-previsao-entrega`,
      {
        products,
        purchase_id,
      }
    );

    return response;
  },

  editarProdutoQuantidade: async (context, { purchase_id, products, uuid }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/purchase-order/${purchase_id}/products`, {
      products,
      purchase_id,
      uuid,
    });

    return response;
  },

  editarProdutosNecessidadeNome: async (
    context,
    { matricula_responsavel, need_id, uuid }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/necessidade-compra/${need_id}/item/${uuid}`,
      {
        uuid,
        matricula_responsavel,
        need_id,
      }
    );

    return response;
  },

  editarProdutosNecessidadeCode: async (
    context,
    { product_uuid, need_id, code }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/necessidade-compra/${need_id}/item/${product_uuid}/trocar`,
      {
        product_uuid,
        need_id,
        code,
      }
    );

    return response;
  },

  editarProdutosNecessidadeNcm: async (context, { ncm, need_id, uuid }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/necessidade-compra/${need_id}/item/${uuid}`,
      {
        need_id,
        uuid,
        ncm,
      }
    );

    return response;
  },

  editarProdutosNecessidadeCost: async (
    context,
    { cost_center_code, need_id, uuid }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/necessidade-compra/${need_id}/item/${uuid}`,
      {
        uuid,
        need_id,
        cost_center_code,
      }
    );

    return response;
  },

  editarProdutosNecessidadeQuantidadeForaCatalogo: async (
    context,
    { uuid, uuidItem, quantidade }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/necessidade-compra/${uuid}/item-fora-catalogo/${uuidItem}/valida-responsavel`,
      {
        item: {
          quantidade: quantidade.toString(),
        },
        need_id: uuid,
        uuid: uuidItem,
      }
    );

    return response;
  },

  editarQuantidadeItemNecessidade: async (
    context,
    { uuid, uuidItem, quantidade }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/necessidade-compra/${uuid}/item/${uuidItem}/valida-responsavel`,
      {
        quantidade: quantidade.toString(),
        need_id: uuid,
        uuid: uuidItem,
      }
    );

    return response;
  },

  criarNovo: async (
    context,
    {
      fluxo_aprovacao,
      necessidade_compra_uuid,
      provider_id,
      receipt_date_forecast,
      tag_id,
      vendor_id,
      billing_date_forecast,
      issue_date,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.post(`/purchase-order`, {
      fluxo_aprovacao,
      necessidade_compra_uuid,
      provider_id,
      receipt_date_forecast,
      tag_id,
      vendor_id,
      billing_date_forecast,
      issue_date,
    });

    return response;
  },

  providerEmpresas: async (context, { per_page, page, search }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/providers`, {
      params: {
        data_inicial: "01/01/2001",
        per_page,
        page,
        search,
      },
    });

    return response;
  },

  criarPedido: async (
    context,
    {
      billing_date_forecast,
      issue_date,
      provider_id,
      receipt_date_forecast,
      vendor_id,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.post(`/purchase-order`, {
      billing_date_forecast,
      issue_date,
      provider_id,
      receipt_date_forecast,
      vendor_id,
      fluxo_aprovacao: [],
    });

    return response;
  },
  listarPedidos: async (
    context,
    { vendor_id, page, per_page, status_aprovacao, status, provider, id }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/purchase-order`, {
      params: {
        vendor: vendor_id,
        page,
        per_page,
        status_aprovacao,
        status,
        provider,
        id,
      },
    });

    return response;
  },
  deletarPedido: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.delete(`/purchase-order/${id}`);

    return response;
  },

  pedidoEspecifico: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/purchase-order/${id}`);

    return response;
  },

  setSuprimento: async (context, { cNumero, purchase_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/purchase-order/atualizar-cnumero/${purchase_id}`,
      {
        cNumero,
        purchase_id,
      }
    );

    return response;
  },

  removerProduto: async (context, { products, purchase_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/purchase-order/${purchase_id}/products/delete`,
      {
        products,
        purchase_id,
      }
    );

    return response;
  },

  logs: async (context, { pedido_id, produto_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/integracao/logs`, {
      params: {
        banco: "logs",
        tabela: "log_integracao_pedido_vale",
        pedido_id,
        produto_id,
      },
    });

    return response;
  },

  jobs: async (context, { payload }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.post(`/integracao/jobs`, {
      job: "RodarIntegracaoPedidoValeJob",
      payload,
    });

    return response;
  },

  ativarContrato: async (context, { purchase_id, products }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/purchase-order/${purchase_id}/products`, {
      products,
      purchase_id,
    });

    return response;
  },

  solicitarAprovacao: async (context, { purchase_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/purchase-order/${purchase_id}/solicitar-aprovacao`,
      {
        purchase_id,
      }
    );

    return response;
  },

  aprovarPedido: async (context, { purchase_id, observacao }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/purchase-order/${purchase_id}/aprovar`, {
      purchase_id,
      observacao,
    });

    return response;
  },

  negarPedido: async (context, { purchase_id, observacao }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/purchase-order/${purchase_id}/reprovar`, {
      purchase_id,
      observacao,
    });

    return response;
  },

  shippedProdutos: async (context, { purchase_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/purchase-order/${purchase_id}/shipped`, {
      purchase_id,
    });

    return response;
  },

  getProducts: async (context, { per_page, provider_id, stock }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/vendors/1/products`, {
      params: {
        per_page,
        provider_id,
        stock,
      },
    });

    return response;
  },

  adicionarProduto: async (context, { product_id, vendors }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/products/${product_id}/consumo-por-item`, {
      params: {
        vendors,
      },
    });

    return response;
  },

  adicionarProdutosManual: async (context, { purchase_id, products }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/purchase-order/${purchase_id}/products`, {
      products,
      purchase_id,
    });

    return response;
  },

  receberComDiferenca: async (context, { purchase_id, produtos }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/purchase-order/${purchase_id}/receber-com-diferenca-por-produto`,
      {
        produtos,
      }
    );

    return response;
  },

  alterarDadosAuxiliares: async (
    context,
    {
      uuid,
      data_aplicacao,
      detalhamento_tecnico,
      responsabilidades_fornecedores,
      responsabilidades_contratante,
      possiveis_fornecedores,
      justificativa_contratacao,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/necessidade-compra/${uuid}/valida-responsavel`,
      {
        data_aplicacao,
        detalhamento_tecnico,
        responsabilidades_fornecedores,
        responsabilidades_contratante,
        possiveis_fornecedores,
        justificativa_contratacao,
      }
    );

    return response;
  },

  pedidosEmAberto: async (
    context,
    {
      vendor_id,
      page,
      per_page,
      nome_aprovador,
      numero_pedido,
      status,
      status_aprovacao,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/products/de-pedidos-em-aberto`, {
      params: {
        data_inicial: "01/01/2001",
        vendor_id,
        page,
        per_page,
        nome_aprovador,
        numero_pedido,
        status,
        status_aprovacao,
      },
    });

    return response;
  },

  exportarPedidosEmAberto: async (context, { vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/products/de-pedidos-em-aberto`, {
      params: {
        data_inicial: "01/01/2001",
        download: "xlsx",
        vendor_id,
      },
    });

    return response;
  },

  adicionarObservacao: async (
    context,
    { purchase_id, observacao, vendor_id, provider_id }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/purchase-order/${purchase_id}`, {
      observacao,
      vendor_id,
      purchase_id,
      provider_id,
    });

    return response;
  },

  fecharPedido: async (context, { purchase_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/purchase-order/${purchase_id}/receber-com-diferenca`,
      {
        purchase_id,
      }
    );

    return response;
  },

  rejeitarEspecial: async (context, { purchase_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/purchase-order/${purchase_id}/reprovar-especial`,
      {
        purchase_id,
      }
    );

    return response;
  },

  receberProdutos: async (context, { purchase_id, products }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/purchase-order/${purchase_id}/products/received`,
      {
        purchase_id,
        products,
        movimentar_estoque: 0,
      }
    );

    return response;
  },

  getSemReferencia: async (
    context,
    { uuid, associado = 0, comprado = 2, numero }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/necessidade-compra/itens-fora-catalogo`, {
      params: {
        data_inicial: "01/01/2001",
        per_page: 1000,
        associado,
        comprado,
        uuid,
        numero,
      },
    });

    return response;
  },

  getSemReferenciaFormSup: async (context, { uuid }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/necessidade-compra/itens-fora-catalogo`, {
      params: {
        data_inicial: "01/01/2001",
        per_page: 1000,

        uuid,
      },
    });

    return response;
  },
};

export const compras = {
  namespaced: true,
  actions,
};
